import styled from "styled-components";

const STPageSubTitle = styled.h2`
  font-size: 16px;
  margin: 25px 0 16px 0;
  width: fit-content;
  font-weight: normal;
`;

export default STPageSubTitle;
